import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material';
import { ReleaseBoardDTO } from 'app/model/releaseBoardDTO';
import { CommonService } from 'app/service/common.service';
import { WriteUsService } from 'app/service/write-us-service';
import * as _ from 'lodash';
@Component({
  selector: 'app-releasehistory',
  templateUrl: './releasehistory.component.html',
  styleUrls: ['./releasehistory.component.scss'],
})
export class ReleasehistoryComponent implements OnInit {
  @Output() closePanelReleasehistory: EventEmitter<boolean> = new EventEmitter();
  parsedJson: any;
  myData: any[];
  myData2: any;
  // nikk: ABD[];
  result: any;
  // ELEMENT_DATA: any[];
  // dataSource = new MatTableDataSource();

  constructor(private writeUsService: WriteUsService, private commonService: CommonService,
    private datePipe: DatePipe) { }
  releaseBoardDTO: ReleaseBoardDTO = new ReleaseBoardDTO();
  ngOnInit() {
    this.getDataList();
    this.getModifiedDate()
  }
  closed() {
    this.closePanelReleasehistory.emit(false);
  }
  getDataList() {
    this.writeUsService.getDataList().subscribe(
      data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.myData = this.parsedJson;
        //Commented on 19/14/2021 for pivot table. this is unused.
        /* this.result = _(data)
           .groupBy(x => x.releaseVersionNo)
           .map((value, key) => ({ releaseVersionNo: key, releaseData: value }))
           .value(); 
           */
        this.result = this.groupBy(this.myData, val => val.releaseVersionNo);
        //End

        // this.result.forEach((element) => {
        // });
        // this.result.forEach((element) => {
        // });
        // // this.myData2 = _.groupBy(this.myData, "releaseVersionNo");
        // // this.nikk = this.myData2;
      },
      error => { }
    );
  }

  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach(item => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }
  asIsOrder(a, b) {
    return 1;
  }

  daeTimeStamp: any;
  parsedJSON: any;
  getModifiedDate() {
    this.commonService.getModifiedDate().subscribe(data => {
      this.parsedJSON = JSON.parse(JSON.stringify(data));
      var angularWarFileDeployDate = this.parsedJSON.UI;
      var javaWarFileDeployDate = this.parsedJSON.Java
      var frontEndDate = this.datePipe.transform(angularWarFileDeployDate, 'dd-MMM-yyyy HH:mm:ss')!;
      var backEndDate = this.datePipe.transform(javaWarFileDeployDate, 'dd-MMM-yyyy HH:mm:ss')!;
      var message = "Front/Back End Build Stamp ";
      this.daeTimeStamp = message + frontEndDate + "/" + backEndDate;
    }),
      error => {

      };
  }
}
